import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import {
  AttackTechniqueChips,
  ThreatActorChips,
  ThreatTypeChips,
} from "./ThreatIntel";

const ThreatIntelAccordion = ({ step, size = "medium" }) => {
  const [expanded, setExpanded] = useState(false);
  const colors = useColors();
  const { trackEvent } = useAPI();
  const handleChange = () => {
    trackEvent("user clicked on threat intel accordion");
    setExpanded(!expanded);
  };
  const sxSmall = {
    accordion: {
      boxShadow: "none",
      margin: "0px 0px",
    },
    accordionSummery: {
      minHeight: "16px",
      height: "16px",
      padding: "0px",
    },
    titleVariantTypography: "subtitle2",
    detailsGap: 1,
  };
  const sxMedium = {
    accordion: {
      boxShadow: " 0px 0px 2px 0px " + colors.secondary_darker,
      margin: "0px 2px",
    },
    accordionSummery: {
      minHeight: "24px",
      height: "26px",
      padding: "0px",
    },
    titleVariantTypography: "subtitle1",
    detailsGap: 2,
  };

  const sizeStyles = {
    small: sxSmall,
    medium: sxMedium,
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        {/* ADVERSARY */}
        <Box>
          <Accordion
            expanded={expanded}
            onChange={handleChange}
            sx={sizeStyles[size].accordion}
            style={{ borderRadius: "8px", padding: "16px" }}
          >
            <AccordionSummary
              expandIcon={<KeyboardArrowDownRoundedIcon />}
              style={sizeStyles[size].accordionSummery}
            >
              <Typography
                variant={sizeStyles[size].titleVariantTypography}
                sx={{
                  fontWeight: 600,
                  flexShrink: 0,
                  color: colors.text_primary,
                }}
              >
                Threat Intel
              </Typography>
            </AccordionSummary>
            <Divider
              orientation="horizontal"
              flexItem
              style={{ marginTop: "10px" }}
            />
            <AccordionDetails sx={{ padding: 0 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mt: 1,
                  gap: 2,
                }}
              >
                {step.possible_threats.length > 0 && (
                  <ThreatTypeChips
                    items={step.possible_threats}
                    justifyContent="flex-start"
                  />
                )}
                {step.mitre_attack_groups.length > 0 && (
                  <ThreatActorChips
                    items={step.mitre_attack_groups?.slice(0, 5)}
                    justifyContent="flex-start"
                  />
                )}
                {step.mitre_attack_techniques.length > 0 && (
                  <AttackTechniqueChips
                    items={step.mitre_attack_techniques?.slice(0, 5)}
                  />
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ThreatIntelAccordion;
